export enum EFetchSseErrorName {
  RESPONSE_CONTENT_TYPE = 'FetchSseError.ResponseContentType',
  RESPONSE_STATUS = 'FetchSseError.ResponseStatus',
  RESPONSE_NO_BODY = 'FetchSseError.ResponseNoBody'
}
